import React from "react";
// import Header3 from "./Header3";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Section1 from "./Section1";
import Section2 from "./Section2";
// import { Section7 } from "../Home/Section7";

export default function IndexContactus() {
  return (
    <div>
      {/* <Header3 /> */}
      <Header/>
      <Section1 />
      <Section2/>
      {/* <Section7 /> */}
      <Footer />
    </div>
  );
}
